module.exports = __webpack_public_path__ + "static/media/1.f66d20e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/remoteSmartLinkIOT/img/1.png
// module id = 464
// module chunks = 0